// extracted by mini-css-extract-plugin
export default {"ModalTitle":"Modals_ModalTitle__668C6","ModalContent":"Modals_ModalContent__P2prZ"};